import { Link } from "react-router-dom";
import { FaHome, FaCode, FaFolderOpen, FaBriefcase, FaEnvelope } from "react-icons/fa";

function Navbar() {
  const navItems = [
    { icon: <FaHome />, label: "Home", path: "/" },
    { icon: <FaCode />, label: "Skills", path: "/skills" },
    { icon: <FaFolderOpen />, label: "Projects", path: "/projects" },
    { icon: <FaBriefcase />, label: "Experience", path: "/experience" },
    { icon: <FaEnvelope />, label: "Contact", path: "/contact" },
  ];

  return (
    <div className="fixed top-6 left-1/2 -translate-x-1/2 z-50">

      <div className="flex gap-6 px-6 py-3 rounded-xl bg-[#0f172a]/80 backdrop-blur-lg border border-white/10 shadow-xl">

        {navItems.map((item, index) => (
          <Link key={index} to={item.path} className="group relative">

            {/* ICON */}
            <div className="text-gray-300 text-lg p-3 rounded-lg transition
            group-hover:text-white
            group-hover:bg-gradient-to-r
            group-hover:from-blue-500
            group-hover:to-indigo-500">

              {item.icon}

            </div>

            {/* TOOLTIP */}
            <span className="absolute -bottom-8 left-1/2 -translate-x-1/2 text-xs text-white bg-black px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition whitespace-nowrap">

              {item.label}

            </span>

          </Link>
        ))}

      </div>

    </div>
  );
}

export default Navbar;